<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="treatmentForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                treatmentForm: () => import('../forms/TreatmentForm'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: 'Chemical Purchase', value: 'chemicalPurchaseId', table: 'chemicalPurchases', form: () => import('../forms/ChemicalPurchaseForm') },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    chemicalPurchases: [],
                    loads: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "loadId", direction: "ascending" },
                    { column: "chemicalPurchaseId", direction: "ascending" },
                ],
                itemsField: 'treatments',
                editPageName: 'treatment',
                apiMethod: 'Treatments',
                claimName: 'Treatments',
                formTitle: 'Treatment',
                excelTitle: 'Treatments',
                hasEditPage: false,
            }
        },
    };
</script>
